import * as alignStyles from './align.module.scss'
import * as spacingStyles from './spacing.module.scss'
import * as paddingStyles from './padding.module.scss'

export const Spacing = {
  base: spacingStyles.base,
  small: spacingStyles.small,
  medium: spacingStyles.medium,
  large: spacingStyles.large,
  xlarge: spacingStyles.xlarge,
  none: spacingStyles.none,
}

export const Align = {
  left: alignStyles.left,
  center: alignStyles.center,
  right: alignStyles.right
}

export const Padding = {
  base: paddingStyles.paddingBase,
  small: paddingStyles.paddingSmall,
  medium: paddingStyles.paddingMedium,
  large: paddingStyles.paddingLarge,
  xlarge: paddingStyles.paddingXlarge,
  none: paddingStyles.paddingNone
}

export enum Logo {
  brand = 'BRAND',
  amazon = 'AMAZON',
  prime = 'PRIME',
  isPrime = 'IS_PRIME',
  primeSash = 'PRIME_SASH',
  imdb = 'IMDB',
  apple = 'APPLE',
  playStore = 'PLAY_STORE',
}
